<template>
  <div :class="this.className" />
</template>

<script>
export default {
  name: 'AppReviewStar',
  props: {
    starType: {
      type: String,
      default: 'full',
      validation (newValue) {
        const validValues = ['full', 'half', 'empty']
        return validValues.includes(newValue)
      }
    }
  },
  computed: {
    className () {
      return `app-review__star_${this.starType}`
    }
  }
}
</script>

<style scoped>
.app-review__star,
.app-review__star_full,
.app-review__star_half,
.app-review__star_empty {
  display: flex;
  object-fit: contain;
  height: 1.5rem;
  width: 1.5rem;
  margin: 0 0.19rem;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

.app-review__star_full {
  background-image: url("/static/stars/Full@2x.png");
}

.app-review__star_half {
  background-image: url("/static/stars/Half@2x.png");
}

.app-review__star_empty {
  background-image: url("/static/stars/Empty@2x.png");
}
</style>
